<template>
	<div class="services_page">
		<!-- ヘッダー -->
		<headerBar></headerBar>
		<div class="image_area" :style="{'background-image':'url(' + bgimage + ')'}"></div>
		<!-- Bicansaについて -->
		<div class="brand_info">
			<div class="logo">
				<img src="@/assets/hp_logo_v3.svg"/>
			</div>
			<div class="text-area">
				<div class="title">Bicansa は当社がご提供するサービスのブランド名です。</div>
				<div class="comment">Bicansa（ビケーンサ）は、沖縄の方言である「ビケーン」が由来で、「特有」とか「ここにしかない」という意味です。当社にしか無い、特別な物をご提供できるようにと名付けられました。</div>
			</div>
		</div>
		<!-- コンテンツ -->
		<div class="contents_area">
			<div class="content_item">
				<a class="ancker_point" id="system"/>
				<div class="title">システム開発</div>
				<div class="bgimage_area">
					<div class="bg_image" :style="{'background-image':'url(' + systemImg + ')'}"></div>
				</div>
				<div class="comment">
					当社は、InterSystems社のCaché<span style="vertical-align:super; font-size:0.6rem">※</span>（およびMUMPS）を利用したデータベースシステム開発を得意とし、
					業務系アプリケーションやデータの二次利用ツール等の自社開発、及び受託開発を行っています。
					システム設計から、開発、導入、保守までお客様のご要望に合わせ高品質なサービスを提供致します。
					また、その他のデータベースを使ったシステムにも対応致します。その他にも業務簡略の為の簡単なツール作成や、
					既存システムの移植開発等も承っておりますので、お気軽にご相談下さい。
				</div>
			</div>
			<div class="content_item">
				<a class="ancker_point" id="webapp"/>
				<div class="title">WEBアプリケーション開発</div>
				<div class="bgimage_area">
					<div class="bg_image" :style="{'background-image':'url(' + webappImg + ')'}"></div>
				</div>
				<div class="comment">
					当社は、WEBアプリケーション技術を使った開発を得意としており、リッチでプログレッシブなアプリケーションをお届け致します。
					モバイルアプリケーションの制作と合わせたソリューションの開発、業務系アプリケーションのWEBシステムへの移行、WEBサービスの制作などに、高い技術力でお応え致します。
				</div>
			</div>
			<div class="content_item">
				<a class="ancker_point" id="design"/>
				<div class="title">WEBサイト制作・各種デザイン</div>
				<div class="bgimage_area">
					<div class="bg_image" :style="{'background-image':'url(' + designImg + ')'}"></div>
				</div>
				<div class="comment">
					会社ホームページや、店舗紹介ホームページなどの制作を行います。お客様のご要望にお答えするために、当社では独自の構築技術により
					他社にない、お客様の「こだわり」に対応したサイトを制作致します。店舗内外や料理、商品等の写真は提携のカメラマンが撮影致します。<br>
					その他にも、企業・団体・その他のロゴや、名刺などもデザイン致します。お客様がご納得頂けるまで誠心誠意対応させて頂きます。<br><br>
					（実績例）<a href="https://www.dining-hana05.com/" target="_blank" rel="noopener">DINING 花</a>
				</div>
			</div>
			<div class="content_item">
				<a class="ancker_point" id="consultant"/>
				<div class="title">システムコンサルタント</div>
				<div class="bgimage_area">
					<div class="bg_image" :style="{'background-image':'url(' + consultantImg + ')'}"></div>
				</div>
				<div class="comment">
					業務簡略化や費用削減、集客などのご要望に対して、ご予算に合ったご提案を致します。既存システムの利活用方法や、
					システム導入計画のご相談だけでも承っておりますので、お気軽にお問い合わせ下さい。
				</div>
			</div>
			<div class="warning">※<a href="https://www.intersystems.com/jp/" target="_blank" rel="noopener">InterSystems Caché</a> は、米国インターシステムコーポレーションおよびその子会社の登録商標です。</div>
		</div>
		<!-- サイトマップ -->
		<sitemap></sitemap>
	</div>
</template>

<script>
import Vue from 'vue'
import headerBar from '@/components/headerBar.vue'
import sitemap from '@/components/map.vue'
export default {
	name: 'servicesPage',
	components: {
		'headerBar': headerBar,
		'sitemap': sitemap
	},
	data() {
		return {
			bgimage: require("@/assets/images/topSlide/image02.jpg"),
			systemImg: require("@/assets/images/system_img.jpg"),
			webappImg: require("@/assets/images/webapp_img.jpg"),
			designImg: require("@/assets/images/design_img.jpg"),
			consultantImg: require("@/assets/images/consultant_img.jpg")
		}
	},
	beforeRouteEnter(to, from ,next) {
		next(vm => {
			if (to.hash.match(/^#/)) {
				let anc = to.hash.replace(/^#/, '');
				vm.$scrollTo("#" + anc);
			} else {
				vm.$scrollTo("#app");
			}
		});
	},
	afterEach(to, from) {
		
	},
	watch: {
		'$route': function(n, o) {
			if (n.hash.match(/^#/)) {
				let anc = n.hash.replace(/^#/, '');
				this.$scrollTo("#" + anc);
			} else {
				this.$scrollTo("#app");
			}
		}
	}
}
</script>

<style lang="less" scoped>
.services_page {
	.image_area {
		width: 100%;
		height: 280px;
		background-size: cover;
		background-position: center;
	}
	
	.brand_info {
		padding: 60px 80px 20px 80px;
		background-color: white;
		text-align: center;
		
		.logo {
			width: 100%;
			padding-bottom: 30px;
			
			img {
				width: 100px;
			}
		}
		
		.text-area {
			text-align: center;
			padding: 0 100px;
			
			.title {
				color: #eb5f1a;
				font-weight: bold;
				font-size: 1.5rem;
			}
			
			.comment {
				padding-top: 20px;
				text-align: left;
			}
		}
	}
	
	.contents_area {
		padding: 60px 80px 20px 80px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		background-color: #fff;
		
		.content_item {
			position: relative;
			width: 480px;
			margin-bottom: 40px;
			
			.ancker_point {
				position: relative;
				top: -80px;
			}
			
			.bgimage_area {
				width: 100%;
				height: 160px;
				padding: 8px 0 12px;
				
				.bg_image {
					width: 100%;
					height: 100%;
					background-size: cover;
					background-position: center;
				}
			}
			
			.title {
				font-size: 1.1rem;
				font-weight: bold;
				padding: 2px 6px;
				border-left: 8px solid #eb5f1a;
				border-bottom: 1px solid #eb5f1a;
				margin-bottom: 10px;
			}
		}
		
		.warning {
			padding: 30px 0;
			font-size: 0.8rem;
		}
		
		a {
			color: #6A6A6A;
			text-decoration: none;
		}
	}
}

@media(max-width:420px) {
	.services_page {
		.brand_info {
			padding: 60px 28px;
			
			.text-area {
				padding: 0;
			}
		}
		
		.contents_area {
			padding: 60px 28px 0px 28px;
			display: flex;
			flex-wrap: wrap;
			justify-content: space-around;
			
			.content_item {
				width: 280px;
				margin-bottom: 100px;
			}
		}
	}
}
</style>
